// source: galaxycompletepb/apipb/domainpb/activity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var galaxycompletepb_apipb_domainpb_user_pb = require('../../../galaxycompletepb/apipb/domainpb/user_pb.js');
goog.object.extend(proto, galaxycompletepb_apipb_domainpb_user_pb);
var galaxycompletepb_apipb_domainpb_deployment_pb = require('../../../galaxycompletepb/apipb/domainpb/deployment_pb.js');
goog.object.extend(proto, galaxycompletepb_apipb_domainpb_deployment_pb);
var galaxycompletepb_apipb_domainpb_project_pb = require('../../../galaxycompletepb/apipb/domainpb/project_pb.js');
goog.object.extend(proto, galaxycompletepb_apipb_domainpb_project_pb);
goog.exportSymbol('proto.galaxycomplete.domain.ActivityInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.galaxycomplete.domain.ActivityInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.galaxycomplete.domain.ActivityInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.galaxycomplete.domain.ActivityInfo.displayName = 'proto.galaxycomplete.domain.ActivityInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.galaxycomplete.domain.ActivityInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.galaxycomplete.domain.ActivityInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.ActivityInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    eventCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    messageTemplate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    data: (f = msg.getData()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    userInfo: (f = msg.getUserInfo()) && galaxycompletepb_apipb_domainpb_user_pb.HubUser.toObject(includeInstance, f),
    deploymentInfo: (f = msg.getDeploymentInfo()) && galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo.toObject(includeInstance, f),
    migrationSessionId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    project: (f = msg.getProject()) && galaxycompletepb_apipb_domainpb_project_pb.ProjectIdentityInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.galaxycomplete.domain.ActivityInfo}
 */
proto.galaxycomplete.domain.ActivityInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.galaxycomplete.domain.ActivityInfo;
  return proto.galaxycomplete.domain.ActivityInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.galaxycomplete.domain.ActivityInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.galaxycomplete.domain.ActivityInfo}
 */
proto.galaxycomplete.domain.ActivityInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageTemplate(value);
      break;
    case 6:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 10:
      var value = new galaxycompletepb_apipb_domainpb_user_pb.HubUser;
      reader.readMessage(value,galaxycompletepb_apipb_domainpb_user_pb.HubUser.deserializeBinaryFromReader);
      msg.setUserInfo(value);
      break;
    case 11:
      var value = new galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo;
      reader.readMessage(value,galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo.deserializeBinaryFromReader);
      msg.setDeploymentInfo(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMigrationSessionId(value);
      break;
    case 13:
      var value = new galaxycompletepb_apipb_domainpb_project_pb.ProjectIdentityInfo;
      reader.readMessage(value,galaxycompletepb_apipb_domainpb_project_pb.ProjectIdentityInfo.deserializeBinaryFromReader);
      msg.setProject(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.galaxycomplete.domain.ActivityInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.galaxycomplete.domain.ActivityInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.ActivityInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEventCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMessageTemplate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getUserInfo();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      galaxycompletepb_apipb_domainpb_user_pb.HubUser.serializeBinaryToWriter
    );
  }
  f = message.getDeploymentInfo();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo.serializeBinaryToWriter
    );
  }
  f = message.getMigrationSessionId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getProject();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      galaxycompletepb_apipb_domainpb_project_pb.ProjectIdentityInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
*/
proto.galaxycomplete.domain.ActivityInfo.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.hasTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string event_code = 3;
 * @return {string}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.getEventCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.setEventCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string message_template = 5;
 * @return {string}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.getMessageTemplate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.setMessageTemplate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Struct data = 6;
 * @return {?proto.google.protobuf.Struct}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.getData = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 6));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
*/
proto.galaxycomplete.domain.ActivityInfo.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.hasData = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional HubUser user_info = 10;
 * @return {?proto.galaxycomplete.domain.HubUser}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.getUserInfo = function() {
  return /** @type{?proto.galaxycomplete.domain.HubUser} */ (
    jspb.Message.getWrapperField(this, galaxycompletepb_apipb_domainpb_user_pb.HubUser, 10));
};


/**
 * @param {?proto.galaxycomplete.domain.HubUser|undefined} value
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
*/
proto.galaxycomplete.domain.ActivityInfo.prototype.setUserInfo = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.clearUserInfo = function() {
  return this.setUserInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.hasUserInfo = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional DeploymentIdentityInfo deployment_info = 11;
 * @return {?proto.galaxycomplete.domain.DeploymentIdentityInfo}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.getDeploymentInfo = function() {
  return /** @type{?proto.galaxycomplete.domain.DeploymentIdentityInfo} */ (
    jspb.Message.getWrapperField(this, galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo, 11));
};


/**
 * @param {?proto.galaxycomplete.domain.DeploymentIdentityInfo|undefined} value
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
*/
proto.galaxycomplete.domain.ActivityInfo.prototype.setDeploymentInfo = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.clearDeploymentInfo = function() {
  return this.setDeploymentInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.hasDeploymentInfo = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string migration_session_id = 12;
 * @return {string}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.getMigrationSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.setMigrationSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional ProjectIdentityInfo project = 13;
 * @return {?proto.galaxycomplete.domain.ProjectIdentityInfo}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.getProject = function() {
  return /** @type{?proto.galaxycomplete.domain.ProjectIdentityInfo} */ (
    jspb.Message.getWrapperField(this, galaxycompletepb_apipb_domainpb_project_pb.ProjectIdentityInfo, 13));
};


/**
 * @param {?proto.galaxycomplete.domain.ProjectIdentityInfo|undefined} value
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
*/
proto.galaxycomplete.domain.ActivityInfo.prototype.setProject = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.ActivityInfo} returns this
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.clearProject = function() {
  return this.setProject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.ActivityInfo.prototype.hasProject = function() {
  return jspb.Message.getField(this, 13) != null;
};


goog.object.extend(exports, proto.galaxycomplete.domain);
